import { useMemo } from "react";
import {
  Stack,
  Text,
  type ComboboxItem,
  type ComboboxLikeRenderOptionInput,
} from "@mantine/core";

export interface PortalNotificationPreferenceComboboxItem extends ComboboxItem {
  description: string;
}

export function PortalNotificationPreferenceOption({
  option,
}: ComboboxLikeRenderOptionInput<ComboboxItem>) {
  const preferenceOption = useMemo(
    () => option as PortalNotificationPreferenceComboboxItem,
    [option]
  );

  return (
    <Stack gap={2} py={4}>
      <Text size="sm" fw={500}>
        {preferenceOption.label}
      </Text>
      <Text size="xs" c="dimmed" style={{ whiteSpace: "normal" }}>
        {preferenceOption.description}
      </Text>
    </Stack>
  );
}
